export default __webpack_public_path__ + "static/media/apple-juice@3x.c751ab11.png";